import type { NodeProps } from "reactflow";
import type { MapViewEntity } from "@/lib/core/schemas/map-view";
import { cn } from "@/lib/utils";

export type EntityTokenNodeData = { entity: MapViewEntity };

export const EntityTokenNode = ({ data }: NodeProps<EntityTokenNodeData>) => {
  const { entity } = data;
  const initials = entity.name.slice(0, 2);
  const tooltip = `${entity.name} (${entity.position?.x ?? "?"}, ${entity.position?.y ?? "?"}, ${entity.position?.z ?? "?"})`;

  return (
    <div
      className={cn(
        "flex h-10 w-10 items-center justify-center rounded-full border font-medium text-xs",
        "data-[side=party]:bg-blue-500 data-[side=party]:text-white",
        "data-[side=hostile]:bg-red-500 data-[side=hostile]:text-white",
        "data-[side=neutral]:bg-gray-400 data-[side=neutral]:text-white"
      )}
      data-entity-id={entity.id}
      data-side={entity.scenarioSide}
      title={tooltip}
    >
      {initials}
    </div>
  );
};
